import React from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import FormComponent from '../Form'
import { Container } from 'semantic-ui-react'
import companyForm from './config/company-form'
import { withAuthentication } from '../Session'
import { withFirebase } from '../Firebase'
import { AutoHeader } from '../Common'

class CompanyCreatePage extends React.Component {
   render() {
      return (
         <Container>
            <AutoHeader />
            <Container>
               <FormComponent form={companyForm} {...this.props} />
            </Container>
         </Container>
      )
   }
}

export default compose(
   withRouter,
   withFirebase,
   withAuthentication,
)(CompanyCreatePage)
